import { z } from 'zod';
import { request, saveAccessToken, getAccessToken } from './client';

const registerInput = z.object({
  email: z.string().email('邮箱格式不正确'),
  password: z.string().min(8, '密码至少 8 位').regex(/[a-zA-Z]/, '需含字母').regex(/\d/, '需含数字'),
  nickname: z.string().min(1).max(32),
});
type RegisterInput = z.infer<typeof registerInput>;

const loginInput = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
type LoginInput = z.infer<typeof loginInput>;

interface AuthResponse {
  userId: string;
  /** JWT access token，用于 Authorization header 与 WebSocket 鉴权 query 参数 */
  accessToken?: string;
}

/**
 * 兼容旧代码：getWsToken 实际返回 access token。
 * 新代码请直接使用 client.ts 的 getAccessToken。
 */
export function getWsToken(): string | null {
  return getAccessToken();
}

/** 登出时清除 token */
export function clearWsToken(): void {
  saveAccessToken(undefined);
}

export const authApi = {
  register: async (body: RegisterInput): Promise<AuthResponse> => {
    const r = await request<AuthResponse>('/auth/register', {
      method: 'POST',
      body: JSON.stringify(body),
    });
    saveAccessToken(r.accessToken);
    return r;
  },
  login: async (body: LoginInput): Promise<AuthResponse> => {
    const r = await request<AuthResponse>('/auth/login', {
      method: 'POST',
      body: JSON.stringify(body),
    });
    saveAccessToken(r.accessToken);
    return r;
  },
  logout: async () => {
    await request<void>('/auth/logout', { method: 'POST' });
    clearWsToken();
  },
  me: () => request<{ id: string; email: string; nickname: string }>('/auth/me'),
};
